import Logo from "common/SVGs/logo";
import React from "react";
import cookie from "js-cookie";

const Header: React.FC<{}> = () => {
    const fullName: string = `${cookie.get("first_name")} ${cookie.get(
        "last_name"
    )}`;
    const initials = (fullName as any).match(/\b(\w)/g).join("");

    return (
        <div className="cmsHeader">
            <div className="pg-container">
                <div className="cmsHeader-login-wrapper">
                    <div className="cmsHeader__login-logo">
                        <a href="#/" className="cmsHeader__login-logo-link">
                          <Logo />
                        </a>
                    </div>

                    <div className="cmsHeader__login-user dropdown">
                        <a
                            href="#/"
                            className="cmsHeader__login-user-wrapper"
                        >
                            <span className="cmsHeader__login-user-box">{initials}</span>

                            <div className="cmsHeader__login-user-info">
                                <p className="cmsHeader__login-user-name">{fullName}</p>
                                {/* <p className="cmsHeader__user-detail">{class_name}</p> */}
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
